
import React from 'react';
import { Col, Row, Button } from 'react-bootstrap';
import confirmIcon from '../../../../../../../../assets/confirm.svg';
import style from './termsheet-submitted.module.scss';

const TermsheetSubmitted = () => {
  return (
    <div className={style['termsheet-component']}>
      <Row>
        <Col>
          <div className={style['termsheet-component-panel']}>
            <div className={style['termsheet-component-panel-header']}>
              SECURITY TERMS SUBMITTED
            </div>
            <div className={style['termsheet-component-panel-logo']}>
              <img src={confirmIcon} />
            </div>
            <div className={style['termsheet-component-panel-body']}>
              <div className={style['text-content']}>
                The Terms of the Security for Listing have been submitted for review.
              </div>
              <div className={style['text-content']}>
                Please await advice of the status of this submission from PDEx Listing Unit.
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  )
}


export default TermsheetSubmitted;




